import { Component } from 'preact';
import s from './style.css';

function calcAngleDegrees(x, y) {
	return (Math.atan2(y, x) * 180) / Math.PI;
}

class Magnetic extends Component {
	getLines() {
		const {
			rows = 5,
			columns = 24,
			x = 50,
			y = 50,
			width = 100,
			height = 100,
			leftColor = 'red',
			rightColor = 'blue'
		} = this.props;

		const perRow = 100 / rows;
		const perCol = 100 / columns;

		const percentagePosition = {
			x: (x / width) * 100,
			y: (y / height) * 100
		};

		return Array.from(Array(rows * columns)).map((_, i) => {
			const id = i;
			const col = Math.floor(i / rows);
			const row = i % rows;
			const x = col * perCol;
			const y = row * perRow;

			const rotation = calcAngleDegrees(
				x + perCol / 2 - percentagePosition.x,
				y + perRow / 2 - percentagePosition.y
			);

			const halfCol = columns / 2;
			const halfRow = rows / 2;

			return {
				id,
				x,
				y,
				col,
				row,
				opacity:
					0.75 -
					Math.abs(row - halfRow) / halfRow +
					(0.75 - Math.abs(col - halfCol) / halfCol),
				rotation,
				color: x / perCol >= columns / 2 ? rightColor : leftColor
			};
		});
	}

	updateLines() {
		const {
			rows = 5,
			columns = 25,
			x = 50,
			y = 50,
			width = 100,
			height = 100
		} = this.props;

		const perRow = 100 / rows;
		const perCol = 100 / columns;

		const percentagePosition = {
			x: (x / width) * 100,
			y: (y / height) * 100
		};

		return this.state.lines.map((line, i) => {
			const x = line.col * perCol;
			const y = line.row * perRow;

			return {
				...line,
				rotation: calcAngleDegrees(
					x + perCol / 2 - percentagePosition.x,
					y + perRow / 2 - percentagePosition.y
				)
			};
		});
	}

	constructor(props) {
		super(props);
		this.getLines = this.getLines.bind(this);
		this.updateLines = this.updateLines.bind(this);

		this.state = {
			lines: []
		};
	}

	componentDidMount() {
		window.addEventListener('load', event => {
			setTimeout(() => {
				this.setState({
					lines: this.getLines()
				});
			}, 100);
		});
	}

	render() {
		if (!this.state.lines.length) {
			return <div key="wrapper" className={s.wrap} style={{ opacity: 0 }} />;
		}

		const { rows = 5, columns = 25 } = this.props;

		const perRow = 100 / rows;
		const perCol = 100 / columns;

		const lines = this.updateLines();

		return (
			<div key="wrapper" className={s.wrap}>
				{lines.map(({ x, y, rotation, color, opacity, row }, i) => (
					<div
						key={i}
						className={s.line}
						style={{
							top: `${y}%`,
							left: `${x}%`,
							width: `${perCol}%`,
							height: `${perRow}%`,
							transform: `rotate(${rotation + 270}deg)`,
							opacity,
							color
						}}
					/>
				))}
			</div>
		);
	}
}

export default Magnetic;



// WEBPACK FOOTER //
// ./components/Magnetic/index.js